// extracted by mini-css-extract-plugin
export default {"checkbox":"UserBasedFilters_checkbox__K2gr5","partition":"UserBasedFilters_partition__fsmwy","title":"UserBasedFilters_title__M6Rv0"};